import useSWR from 'swr';
import { categoryDataFetcher } from './api';
import { API } from '../constants';
import { SWR_CONFIG } from './config';
import { CategoryKind, Nullable, MakesResponse } from '../types';

export const useMakes = (categoryId: Nullable<CategoryKind>) => {
  const key = categoryId ? ([API.MAKES, categoryId] as const) : null;
  const { data, isLoading } = useSWR<MakesResponse>(key, categoryDataFetcher, SWR_CONFIG);

  return { data, isLoading };
};
